var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYtWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.489,
    height: 14.343,
    viewBox: "0 0 20.489 14.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M486.64,159.323a4.46,4.46,0,0,0-4.46-4.46H470.611a4.46,4.46,0,0,0-4.46,4.46v5.422a4.46,4.46,0,0,0,4.46,4.46h11.569a4.46,4.46,0,0,0,4.46-4.46Zm-7.3,2.984-4.614,2.53c-.2.109-.381-.036-.381-.265v-5.194c0-.231.186-.375.387-.262l4.646,2.664A.3.3,0,0,1,479.341,162.307Z",
    transform: "translate(-466.151 -154.863)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtWhite);
export default __webpack_public_path__ + "static/media/yt-white.c0490196bcab31804eb5f410bd7b7a4d.svg";
export { ForwardRef as ReactComponent };